import * as React from 'react';
import { connect } from 'react-redux';

import { Navbar } from '../components/Navbar';
import { InGameButton } from '../components/InGameButton';
import '../styles/home.css';

export class UnwrappedHome extends React.Component {
  render() {
    const { authedUser } = this.props
    return (
      <div className="home">
        <Navbar />
        <p>Good afternoon, {authedUser.name}.</p>
        <InGameButton />
      </div>
    )
  }
}

function mapStateToProps ({ authedUser }) {
  return {
    authedUser
  }
}

export const Home = connect(mapStateToProps)(UnwrappedHome);